<template>
  <v-card class="rbu-search-datapoint">
    <v-card-title></v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <!-- <v-autocomplete
            outlined
            label="Period"
            :items="periods"
            v-model="selectedPeriod"
            :rules="requiredRules"
          ></v-autocomplete> -->
        <v-autocomplete
          outlined
          label="Dataset"
          :items="issues"
          v-model="selectedIssueId"
          :rules="requiredRules"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          label="Data Point"
          :items="datapoints"
          v-model="selectedDatapointId"
          :rules="requiredRules"
        >
        </v-autocomplete>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && $emit('submit', selectedDatapointId)"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import _ from "lodash";
import { RBU_DATASET_VALUE_TYPE } from "@/constants";

export default {
  name: "ContractYearRbuDatapointSearchDialog",
  props: {
    datasetType: String,
    period: String,
    issue_id: String,
    datapoint_id: String,
    dataset_id: String,
    selected_datasets: Object,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const periods = ref([]);
    const getPeriods = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/periods/",
        params: {
          page_size: -1,
        },
      });

      if (response.body.success) {
        periods.value = response.body.periods.map((p) => {
          return {
            text: root.$parsePeriod(p),
            value: p,
          };
        });
      }
    };
    const selectedPeriod = ref(props.period);

    const issues = ref([]);
    const getIssues = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/issue/",
        params: {
          filters: {
            // "dataset.types.name": [props.datasetType],
            period: [selectedPeriod.value],
            dataset: props.selected_datasets.value,
          },
          page_size: -1,
        },
      });

      if (response.body.success) {
        issues.value = _.uniqBy(response.body.issues, "dataset.id").map((i) => {
          return {
            text: `[${i.dataset.alias}] - ${i.dataset.title}`,
            value: i.id,
          };
        });
      }
    };
    const selectedIssueId = ref(props.issue_id);

    const datapoints = ref([]);
    const getDatapoints = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/datapoint/",
        params: {
          filters: {
            issue: [selectedIssueId.value],
          },
          page_size: -1,
        },
      });

      if (response.body.success) {
        datapoints.value = _.sortBy(response.body.points, "descriptions").map(
          (p) => {
            return {
              text: `${p.descriptions} (${
                p.dataset.value_type === RBU_DATASET_VALUE_TYPE.PRICE
                  ? root.$parseCurrency(p.value)
                  : root.$parseNumber(p.value)
              })`,
              value: p.id,
            };
          }
        );
      }
    };
    const selectedDatapointId = ref(props.datapoint_id);

    watch(
      () => selectedPeriod.value,
      (newValue) => {
        // console.log('selectedPeriod.value', newValue)
        if (newValue) {
          getIssues();
        }
      },
      { immediate: true }
    );
    watch(
      () => selectedIssueId.value,
      (newValue) => {
        // console.log('selectedIssueId.value', newValue)
        if (newValue) {
          getDatapoints();
        }
      },
      { immediate: true }
    );
    watch(
      () => selectedDatapointId.value,
      (newValue) => {
        // console.log('selectedDatapointId.value', newValue)
      }
    );

    onMounted(() => {
      getIssues();
    });

    return {
      requiredRules,

      periods,
      selectedPeriod,
      issues,
      selectedIssueId,
      datapoints,
      selectedDatapointId,
    };
  },
};
</script>
